module.exports = __webpack_public_path__ + "media/error2.2bed144a.mp3";